export default "__VITE_ASSET__sK3Aez3u__"